import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PortalShell from '../components/PortalShell';
import ResponsiveTable from '../components/ui/ResponsiveTable';
import { Globals } from '../globalfunctions.js';
import { apiClient } from '../utils/apiClient';

function PortalDomains() {
  const navigate = useNavigate();
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Globals.LoginTime === null) {
      localStorage.setItem('redirectAfterLogin', window.location.pathname);
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    (async () => {
      try {
        setDomains(await apiClient.get('/api/domains/mine'));
      } catch (error) {
        console.error('Error fetching domains:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const columns = [
    { key: 'domain_name', label: 'Domain', sortable: true },
    { key: 'registrar', label: 'Registrar' },
    {
      key: 'expiry_date',
      label: 'Renews',
      sortable: true,
      render: (row) => row.expiry_date ? new Date(row.expiry_date).toLocaleDateString() : '—'
    },
    { key: 'status', label: 'Status' }
  ];

  return (
    <PortalShell>
      <h1>Domains</h1>
      {loading ? (
        <p>Loading your domains...</p>
      ) : (
        <ResponsiveTable columns={columns} rows={domains} rowKey="id" emptyMessage="You don't have any domains on file." />
      )}
    </PortalShell>
  );
}

export default PortalDomains;
